import {backEndLink} from "../constants";
import * as axios from "axios";

const header = (token) => {
    const headers = {headers: {Authorization: 'Bearer '.concat(token)},};
    return headers;
};

export const me = ({access_token}) => axios.get((backEndLink + 'moderators/me'), header(access_token));

export const loginFetch = ({email, password}) => axios.post(backEndLink + 'moderators/auth/sign-in/', {
    email,
    password
});

export const restorePasswordFetch = ({email}) => axios.post(backEndLink + 'moderators/auth/reset-password/', {email});
export const signUpFetch = ({email, name}) => axios.post(backEndLink + 'moderators/auth/sign-up/', {email, name});

export const getVideosFetch = ({access_token}) => axios.get((backEndLink + 'moderators/videos'), header(access_token));

export const postVideoFetch = ({video, access_token}) => {
    let bodyFormData = new FormData();
    bodyFormData.append('video', video);
    return axios.post(backEndLink + 'moderators/videos', bodyFormData, header(access_token));
};

export const removeVideoFetch = ({id, access_token}) =>
    axios.delete(backEndLink + 'moderators/videos/' + id, header(access_token));


